import React, { useState, useEffect } from 'react';
import Plot from 'react-plotly.js';
import './styles.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { usePlotlyConfig } from '../../hooks/useResponsive';

const StatusTime = () => {
    const [data, setData] = useState([]);
    const { getPlotlyConfig, getPlotlyLayout } = usePlotlyConfig();

    useEffect(() => {
        // Substitua pelo link CSV da sua planilha
        const sheetUrl = process.env.REACT_APP_SHEET_2_URL;

        fetch(sheetUrl)
            .then((response) => response.text())
            .then((csvText) => {
                const rows = csvText.split('\n').map((row) => row.split(','));
                setData(rows);
            })
            .catch((error) => console.error('Error fetching data:', error));
    }, []);

    if (data.length === 0) {
        return null; // Retorna null em vez de spinner, deixa o skeleton da página principal gerenciar o loading
    }

    console.log('data:', data);

    // Ajustando os valores e datas
    const initialValues = data.slice(2).map((row) => row.slice(1)); // Corrige para pegar os dados corretos
    const okValues = initialValues.map((row) =>
        row.map((value) => (value === 'OK' ? 1 : 0))
    ); // Converte "OK" para 1 e vazio para 0

    const xValues = data[0].slice(1); // Datas ou meses

    // Obter a data de hoje
    const today = new Date().toISOString().split('T')[0]; // Formato ISO, sem horas

    console.log("initialValues:", initialValues);
    console.log('okValues:', okValues);
    console.log('xValues:', xValues);


    return (
        <div className='container-fluid vh-100 w-100 justify-content-center align-items-center'>
            <Plot
                config={getPlotlyConfig()}
                data={[
                    {
                        z: okValues, // Matriz bidimensional de valores "OK" e "Não OK"
                        x: xValues, // Datas ou meses
                        y: data.slice(2).map((row) => row[0]), // Labels das linhas (se houver)
                        type: 'heatmap',
                        colorscale: [
                            [0, '#f1f1f1'], // Cor para 'Não OK'
                            [1, '#37aa51'], // Cor para 'OK'
                        ],
                        showscale: false,
                    },
                ]}
                layout={getPlotlyLayout({
                    title: 'Acompanhamento mensal de contribuintes',
                    width: 1200,
                    height: 1000,
                    xaxis: {
                        range: ['2013-12-01', '2024-12-01'], // Faixa do eixo x
                    },
                    yaxis: {
                        autorange: 'reversed', // Inverte a ordem do eixo y
                        standoff: 40, // Aumenta a distância entre o título e o eixo
                        ticklabelposition: 'outside', // Coloca os rótulos do eixo fora
                        tickpadding: 10, // Define um padding maior entre os rótulos e o eixo
                    },
                    shapes: [
                        {
                            type: 'line',
                            x0: today, // Data de hoje no eixo x
                            x1: today, // Mesmo valor para x1 para fazer uma linha vertical
                            y0: 0, // Linha vai de 0 no eixo y
                            y1: 1, // Até o topo do gráfico
                            xref: 'x', // Referência ao eixo x
                            yref: 'paper', // 'paper' vai de 0 a 1 no eixo y
                            line: {
                                color: 'black', // Cor da linha
                                width: 1, // Espessura da linha
                                dash: 'solid', // Linha tracejada
                            },
                        },
                    ],

                    annotations: [
                        {
                            x: today, // Data de hoje
                            y: 0.99, // Posição vertical do balão (topo do gráfico)
                            xref: 'x',
                            yref: 'paper', // yref 'paper' faz o eixo y ir de 0 a 1
                            text: ' Hoje ', // Texto a ser exibido no balão
                            showarrow: true, // Exibe uma seta apontando para a linha
                            arrowhead: 3, // Formato da seta
                            ax: -50, // Deslocamento horizontal da seta (sem deslocamento)
                            ay: 20, // Deslocamento vertical da seta
                            font: {
                                size: 14, // Tamanho da fonte do texto
                                color: 'black', // Cor do texto
                            },
                            bgcolor: 'white', // Cor de fundo do balão
                            bordercolor: 'black', // Cor da borda do balão
                            borderwidth: 0.8, // Espessura da borda
                        },
                    ],
                })}
            />
        </div>
    );
};

export default StatusTime;
